import { axiosClient } from '../../../shared/api';

export const listInvoices = async (query = '') => {
  const response = await axiosClient.get(`/invoices${query}`);
  return response.data;
};

export const getInvoice = async (invoiceId) => {
  const response = await axiosClient.get(`/invoices/${invoiceId}`);
  return response.data;
};

export const createInvoice = async (invoiceData) => {
  const response = await axiosClient.post('/invoices', invoiceData);
  return response.data;
};

export const updateInvoice = async (invoiceId, updatedData) => {
  const response = await axiosClient.put(`/invoices/${invoiceId}`, updatedData);
  return response.data;
};

export const getInvoiceStats = async () => {
  const response = await axiosClient.get('/invoices/stats');
  return response.data;
};
